import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import MinimisedSection from '../../../../../../../components/MinimisedSection'
import MinimisedSectionHeader from '../../../../../../../components/MinimisedSection/MinimisedSectionHeader'

import useStyles from './styles'

const InventoryItemSection = ({ children, name, headerChildren, titleClassName, initialIsOpened = false }) => {
  const classes = useStyles()

  const [isOpened, setIsOpened] = useState(initialIsOpened)

  const onClickHandler = useCallback(() => {
    setIsOpened(prevState => !prevState)
  }, [setIsOpened])

  return (
    <MinimisedSection
      className={classes.minimizeSection}
      headerClassName={classes.sectionHeader}
      headerContent={
        <MinimisedSectionHeader titleClassName={titleClassName} title={name}>
          {headerChildren}
        </MinimisedSectionHeader>
      }
      isOpened={isOpened}
      onHeaderClick={onClickHandler}
      bodyClassName={classes.body}
    >
      {React.cloneElement(children, { isOpened })}
    </MinimisedSection>
  )
}

InventoryItemSection.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string.isRequired,
  headerChildren: PropTypes.node,
  titleClassName: PropTypes.string,
  initialIsOpened: PropTypes.bool
}

export default InventoryItemSection
